import React, { Component } from 'react';
import { Container, Row, Col, Tab, Nav, Card, Form, Button, Spinner, InputGroup, Dropdown } from 'react-bootstrap';
import { withApollo } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import * as Cookies from 'es-cookie';
import * as compose from 'lodash.flowright';
import gql from 'graphql-tag';
import { 
    GET_WHATSAPP_TEMPLATES, 
    SEND_WHATSAPP_TEMPLATE, 
    SEND_WHATSAPP_MESSAGE,
    GET_WHATSAPP_CONTACTS,
    GET_WHATSAPP_TAGS,
    GET_BRANCHES
} from '../../utils/whatsappHelper';
import { GET_SMS_TEMPLATES, triggerSms } from '../../utils/smsHelper';
import { triggerEmail } from '../../utils/emailHelper';
import TimelineViewer from './TimelineViewer';
import LeadSidecar from './LeadSidecar';
import './_admissionForms.scss';



class CommunicationsCenterPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 'whatsapp',
            loading: false,
            sending: false,
            
            // Channel specific data
            whatsappTemplates: [],
            smsTemplates: [],
            emailTemplates: [
                { id: '1', name: 'Welcome Email', subject: 'Welcome to Rizee College', body: 'Dear {student_name}, Welcome to Rizee College! We are excited to have you.' },
                { id: '2', name: 'Admission Test Invite', subject: 'Admission Test Schedule', body: 'Hello {student_name}, Your admission test is scheduled for tomorrow.' }
            ],

            // Selection state
            selectedTemplate: '',
            messageBody: '',
            emailSubject: '',
            
            // WhatsApp dynamic variable inputs
            templateVariables: [],   // array of { label: string, value: string, autoFilled: bool }
            templateBodyText: '',    // raw body text with {{n}} placeholders
            
            // Recipient selection
            students: [],
            selectedStudents: [], // IDs of selected students
            searchQuery: '',
            
            // Segment Filtering
            tags: [],
            branches: [],
            selectedTags: [],
            selectedBranches: [],
            
            // WhatsApp Integration
            employeeId: null,
            fetchingTemplates: false,
            
            // Current Selection for Timeline/Sidecar
            selectedMobile: '',
            selectedStudentName: '',
            selectedContactId: null,
            showTimeline: true,
            
            // Rich Media
            mediaUrl: '',
            mediaType: 'text', // text, image, video, audio, document

            // UI Interaction
            registryOpen: false,
            inspectorOpen: false,
        };
    }

    getAuthorizedIds = () => {
        let authorizedIds = [];
        try {
            const cookie = Cookies.get("branch_id") || Cookies.get("branchid");
            if (cookie) {
                if (cookie.startsWith('[')) {
                    authorizedIds = JSON.parse(cookie);
                } else {
                    authorizedIds = cookie.split(",").map(id => id.trim());
                }
            }
        } catch (e) {
            console.warn("Error parsing branch_id cookie", e);
        }
        return authorizedIds.map(String);
    };

    getPermittedBranchIds = () => {
        let permittedBranchIds = [];
        try {
            const branchesCookie = Cookies.get("branches");
            const singleId = Cookies.get("branch_id") || Cookies.get("branchid");

            if (branchesCookie) {
                if (branchesCookie.startsWith('[')) {
                    permittedBranchIds = JSON.parse(branchesCookie).map(id => parseInt(id));
                } else {
                    permittedBranchIds = branchesCookie.split(',').map(id => parseInt(id.trim())).filter(id => !isNaN(id));
                }
            } else if (singleId) {
                permittedBranchIds = [parseInt(singleId)];
            }
        } catch (e) {
            console.warn("Error parsing branches cookie", e);
        }
        return permittedBranchIds;
    };

    componentDidMount() {
        this.fetchInitialData();
    }

    fetchInitialData = async () => {
        console.log("Starting fetchInitialData...");
        this.setState({ loading: true });
        try {
            const username = Cookies.get('username');
            const institutionId = parseInt(Cookies.get('institutionid')) || 0;
            const branchId = parseInt(Cookies.get('branch_id')) || parseInt(Cookies.get('branchid')) || 0;
            console.log("Cookies found for context:", { username, institutionId, branchId });

            // Initialize WhatsApp employeeId
            let employeeId = parseInt(Cookies.get('id'));
            console.log("Using WhatsApp employeeId:", employeeId);

            // Fetch contacts for selection from C3CRM
            console.log("Fetching WhatsApp contacts...");
            let students = [];
            try {
                const contactResult = await this.props.client.query({
                    query: GET_WHATSAPP_CONTACTS,
                    variables: { employee_id: employeeId },
                    fetchPolicy: 'network-only'
                });
                
                let parsedContacts = contactResult.data.getWhatsAppContacts;
                if (typeof parsedContacts === 'string') {
                    parsedContacts = JSON.parse(parsedContacts);
                }
                console.log("Parsed WhatsApp contacts response:", parsedContacts);
                
                if (parsedContacts && parsedContacts.data && parsedContacts.data.messages) {
                     // Map to expected structure for the UI
                     students = parsedContacts.data.messages.map((c, index) => ({
                        id: c.wa_contact_id || index,
                        student_name: c.name || c.mobile,
                        student_mobile: String(c.mobile), // Ensure it's a string
                        student_email: c.email || '',
                        tag_id: c.tag_id,
                        branch_id: c.branch_id
                     }));
                }
            } catch(e) {
                 console.error("Failed to fetch WA contacts:", e);
            }
            console.log("Students/Contacts formatted:", students.length);
            
            // Fetch Tags and Branches in parallel with contacts
            console.log("Fetching Tags and Branches...");
            const [tagsResult, branchesResult] = await Promise.all([
                this.props.client.query({ 
                    query: GET_WHATSAPP_TAGS, 
                    variables: { employee_id: employeeId },
                    fetchPolicy: 'network-only'
                }),
                this.props.client.query({
                    query: GET_BRANCHES,
                    variables: { institution_id: institutionId },
                    fetchPolicy: 'network-only'
                })
            ]);

            const tags = tagsResult.data.getWhatsAppTags?.data || [];
            let branches = branchesResult.data.getBranches || [];
            
            const authorizedIds = this.getAuthorizedIds();
            const permittedIds = this.getPermittedBranchIds();

            branches = branches.filter(b => authorizedIds.includes("all") || authorizedIds.includes(String(b.id)));
            if (permittedIds.length > 0) {
                branches = branches.filter(b => permittedIds.includes(parseInt(b.id)));
            }

            console.log(`Fetched ${tags.length} tags and ${branches.length} branches.`);

            this.setState({ 
                students, 
                tags,
                branches,
                employeeId,
                loading: false 
            }, () => {
                console.log("Calling fetchWAContent and fetchSMSContent...");
                this.fetchWAContent(employeeId);
                this.fetchSMSContent(institutionId, branchId);
            });
        } catch (error) {
            console.error("CRITICAL error in fetchInitialData:", error);
            this.setState({ loading: false });
        }
    };

    fetchWAContent = async (employeeId) => {
        if (!employeeId) return;
        this.setState({ fetchingTemplates: true });
        try {
            const result = await this.props.client.query({
                query: GET_WHATSAPP_TEMPLATES,
                variables: { employee_id: parseInt(employeeId) },
                fetchPolicy: 'network-only'
            });
            
            const templates = result.data.getWhatsAppTemplates?.data || [];
            console.log("Fetched WhatsApp templates:", templates);
            this.setState({ whatsappTemplates: templates, fetchingTemplates: false });
        } catch (error) {
            console.error("Failed to fetch WA templates:", error);
            this.setState({ fetchingTemplates: false });
        }
    };

    fetchSMSContent = async (instituteId, branchId) => {
        if (!instituteId || !branchId) {
            console.warn("Missing instituteId or branchId, skipping SMS templates fetch.");
            return;
        }
        try {
            const result = await this.props.client.query({
                query: GET_SMS_TEMPLATES,
                variables: {
                    institute_id: instituteId,
                    branch_id: branchId
                }
            });
            this.setState({ smsTemplates: result.data.getSMSTemplates || [] });
        } catch (error) {
            console.error("Failed to fetch SMS templates:", error);
        }
    };

    handleTabSelect = (key) => {
        this.setState({ 
            activeTab: key,
            selectedTemplate: '',
            messageBody: '',
            emailSubject: ''
        });
    };

    // Helper: parse components and extract variable info
    parseTemplateComponents = (components) => {
        if (!components) return { bodyText: '', paramCount: 0 };
        try {
            const comps = typeof components === 'string' ? JSON.parse(components) : components;
            if (!Array.isArray(comps)) return { bodyText: '', paramCount: 0 };
            const bodyComp = comps.find(c => c.type === 'BODY');
            if (!bodyComp?.text) return { bodyText: '', paramCount: 0 };
            const matches = bodyComp.text.match(/\{\{\d+\}\}/g);
            return { bodyText: bodyComp.text, paramCount: matches ? matches.length : 0 };
        } catch (e) {
            return { bodyText: '', paramCount: 0 };
        }
    };

    handleTemplateChange = (e) => {
        const tplId = e.target.value;
        this.setState({ selectedTemplate: tplId, templateVariables: [], templateBodyText: '' });
        
        let template;
        if (this.state.activeTab === 'whatsapp') {
            template = this.state.whatsappTemplates.find(t => String(t.id) === String(tplId));
            if (template) {
                const { bodyText, paramCount } = this.parseTemplateComponents(template.components);

                // Build variable inputs — positionally pre-fill known student fields
                const AUTO_FILL_LABELS = [
                    { label: 'Student Name', hint: 'e.g. John Doe' },
                    { label: 'Mobile Number', hint: 'e.g. 919999999999' },
                    { label: 'Email', hint: 'e.g. john@example.com' },
                    { label: 'Date', hint: 'e.g. 20th March 2025' },
                    { label: 'Time', hint: 'e.g. 10:00 AM' },
                    { label: 'Location', hint: 'e.g. KPHB Branch' },
                ];

                const templateVariables = Array.from({ length: paramCount }, (_, i) => ({
                    placeholder: `{{${i + 1}}}`,
                    label: AUTO_FILL_LABELS[i]?.label || `Variable ${i + 1}`,
                    hint: AUTO_FILL_LABELS[i]?.hint || '',
                    value: '',          // staff will fill this in
                    autoFill: i < 2,   // first two are auto-filled per-student at send time
                }));

                this.setState({
                    templateVariables,
                    templateBodyText: bodyText,
                    // Preview: replace {{n}} with placeholder labels
                    messageBody: bodyText || `[Template: ${template.template_name}]`
                });
            }
        } else if (this.state.activeTab === 'sms') {
            template = this.state.smsTemplates.find(t => t.template_id === tplId);
            if (template) this.setState({ messageBody: template.template_text });
        } else if (this.state.activeTab === 'email') {
            template = this.state.emailTemplates.find(t => t.id === tplId);
            if (template) {
                this.setState({ 
                    messageBody: template.body,
                    emailSubject: template.subject 
                });
            }
        }
    };

    toggleStudentSelection = (student) => {
        const studentId = student.id;
        const { selectedStudents } = this.state;
        
        let newSelection;
        if (selectedStudents.includes(studentId)) {
            newSelection = selectedStudents.filter(id => id !== studentId);
        } else {
            newSelection = [...selectedStudents, studentId];
        }
        
        this.setState({ 
            selectedStudents: newSelection,
            selectedMobile: student.student_mobile,
            selectedStudentName: student.student_name,
            selectedContactId: student.id
        });
    };

    selectAllStudents = () => {
        const { filteredStudents, selectedStudents } = this.getFilteredStudentsState();
        const filteredIds = filteredStudents.map(s => s.id);
        
        if (filteredIds.every(id => selectedStudents.includes(id))) {
            this.setState({ selectedStudents: selectedStudents.filter(id => !filteredIds.includes(id)) });
        } else {
            const newSelection = Array.from(new Set([...selectedStudents, ...filteredIds]));
            this.setState({ selectedStudents: newSelection });
        }
    };

    toggleTag = (tagId) => {
        const { selectedTags } = this.state;
        const newTags = selectedTags.includes(String(tagId)) 
            ? selectedTags.filter(id => id !== String(tagId))
            : [...selectedTags, String(tagId)];
        this.setState({ selectedTags: newTags });
    };

    toggleBranch = (branchId) => {
        const { selectedBranches } = this.state;
        const newBranches = selectedBranches.includes(String(branchId)) 
            ? selectedBranches.filter(id => id !== String(branchId))
            : [...selectedBranches, String(branchId)];
        this.setState({ selectedBranches: newBranches });
    };

    toggleAllBranches = () => {
        const { branches, selectedBranches } = this.state;
        const allIds = branches.map(b => String(b.id));
        if (allIds.every(id => selectedBranches.includes(id))) {
            this.setState({ selectedBranches: [] });
        } else {
            this.setState({ selectedBranches: allIds });
        }
    };

    toggleAllTags = () => {
        const { tags, selectedTags } = this.state;
        const allIds = tags.map(t => String(t.id));
        if (allIds.every(id => selectedTags.includes(id))) {
            this.setState({ selectedTags: [] });
        } else {
            this.setState({ selectedTags: allIds });
        }
    };

    getFilteredStudentsState = () => {
        const { students, searchQuery, selectedBranches, selectedTags } = this.state;
        
        const filteredStudents = students.filter(s => {
            const matchesSearch = 
                s.student_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                (s.student_mobile && s.student_mobile.includes(searchQuery)) ||
                (s.student_email && s.student_email.toLowerCase().includes(searchQuery.toLowerCase()));
            
            const matchesBranch = selectedBranches.length > 0 
                ? (s.branch_id ? String(s.branch_id).split(',').some(b => selectedBranches.includes(b.trim())) : false)
                : true;
                
            const matchesTag = selectedTags.length > 0 
                ? (s.tag_id ? String(s.tag_id).split(',').some(t => selectedTags.includes(t.trim())) : false)
                : true;
            
            return matchesSearch && matchesBranch && matchesTag;
        });
        return { filteredStudents, selectedStudents: this.state.selectedStudents };
    }

    handleSend = async () => {
        const { activeTab, selectedStudents, students, messageBody, emailSubject, selectedTemplate } = this.state;
        
        if (selectedStudents.length === 0) {
            alert("Please select at least one recipient.");
            return;
        }
        
        if (!messageBody.trim()) {
            alert("Message body cannot be empty.");
            return;
        }

        this.setState({ sending: true });
        let successCount = 0;
        let failCount = 0;

        for (const id of selectedStudents) {
            const student = students.find(s => s.id === id);
            if (!student) continue;

            let success = false;
            let personalizedBody = messageBody.replace(/{student_name}/g, student.student_name);

            try {
                if (activeTab === 'whatsapp') {
                    if (selectedTemplate) {
                        // Build variables array from state, auto-filling position 0→name, 1→mobile
                        const AUTO_VALUES = [student.student_name, student.student_mobile, student.student_email];
                        let templateVariables = null;
                        if (this.state.templateVariables.length > 0) {
                            templateVariables = this.state.templateVariables.map((v, i) =>
                                v.autoFill ? (AUTO_VALUES[i] || v.value || '') : v.value
                            );
                        }

                        // Send as template — only attach variables if template has placeholders
                        const result = await this.props.client.mutate({
                            mutation: SEND_WHATSAPP_TEMPLATE,
                            variables: {
                                employee_id: parseInt(this.state.employeeId),
                                mobile: student.student_mobile,
                                name: student.student_name,
                                template_id: parseInt(selectedTemplate),
                                ...(templateVariables ? { variables: templateVariables } : {})
                            }
                        });
                        success = result.data.sendWhatsAppTemplate?.success;
                        console.log(`WhatsApp Template Send Result for ${student.student_mobile}:`, result.data.sendWhatsAppTemplate);

                    } else {
                        // Send as free-form message with rich media support
                        const result = await this.props.client.mutate({
                            mutation: SEND_WHATSAPP_MESSAGE,
                            variables: {
                                employee_id: parseInt(this.state.employeeId),
                                mobile: student.student_mobile,
                                message: personalizedBody,
                                name: student.student_name,
                                type: this.state.mediaUrl ? this.state.mediaType : 'text',
                                media_url: this.state.mediaUrl || null
                            }
                        });
                        success = result.data.sendWhatsAppMessage?.success;
                        console.log(`WhatsApp Message Send Result for ${student.student_mobile}:`, result.data.sendWhatsAppMessage);
                    }
                } else if (activeTab === 'sms') {
                    success = await triggerSms(this.props.client, {
                        student,
                        type: 'MANUAL',
                        customData: { message: personalizedBody, template_id: selectedTemplate }
                    });
                } else if (activeTab === 'email') {
                    success = await triggerEmail(this.props.client, {
                        student,
                        type: 'MANUAL',
                        customData: { subject: emailSubject, message: personalizedBody }
                    });
                }
                
                if (success) successCount++;
                else failCount++;
            } catch (err) {
                console.error(`Failed to send to student ${id}:`, err);
                failCount++;
            }
        }

        this.setState({ sending: false });
        alert(`Finished sending messages.\nSuccess: ${successCount}\nFailed: ${failCount}`);
        if (successCount > 0) {
            this.setState({ selectedStudents: [] });
        }
    };

    toggleRegistry = () => this.setState({ registryOpen: !this.state.registryOpen, inspectorOpen: false });
    toggleInspector = () => this.setState({ inspectorOpen: !this.state.inspectorOpen, registryOpen: false });
    closeDrawers = () => this.setState({ registryOpen: false, inspectorOpen: false });

    render() {
        const { 
            activeTab, loading, sending, searchQuery, fetchingTemplates, selectedTemplate, messageBody, emailSubject, selectedStudents,
            selectedStudentName, selectedMobile, selectedContactId, showTimeline,
            registryOpen, inspectorOpen
        } = this.state;

        const { filteredStudents } = this.getFilteredStudentsState();

        if (loading) {
            return (
                <div className="cc-pro-layout-wrapper pb-5">
                    <div className="d-flex justify-content-between align-items-center mb-4 mt-2">
                        <div className="af-skeleton-box w-25 h-30"></div>
                        <div className="af-skeleton-box w-15 h-35" style={{ borderRadius: '8px' }}></div>
                    </div>
                    <div className="cc-pro-layout bg-white" style={{ height: '700px', opacity: 0.6 }}>
                         <div className="cc-pro-registry border-right" style={{ width: '320px' }}>
                             <div className="p-4">
                                 <div className="af-skeleton-box w-50 h-15 mb-4"></div>
                                 <div className="af-skeleton-input mb-4"></div>
                                 {[1,2,3,4,5].map(i => (
                                     <div key={i} className="d-flex align-items-center mb-3">
                                         <div className="af-skeleton-box rounded mr-3" style={{ width: '40px', height: '40px' }}></div>
                                         <div className="flex-fill"><div className="af-skeleton-box w-75 h-12"></div></div>
                                     </div>
                                 ))}
                             </div>
                         </div>
                         <div className="cc-pro-workspace flex-fill d-flex flex-column">
                             <div className="workspace-header border-bottom d-flex align-items-center px-4">
                                 <div className="af-skeleton-box w-30 h-20"></div>
                             </div>
                             <div className="flex-fill p-5 d-flex flex-column align-items-center justify-content-center">
                                 <Spinner animation="border" variant="primary" />
                                 <p className="mt-3 text-muted small">Synchronizing Universal Inbox...</p>
                             </div>
                         </div>
                    </div>
                </div>
            );
        }

        return (
            <div className="cc-pro-layout-wrapper pb-5">
                {/* ── Page Header (Minimal & Elegant) ── */}
                <div className="d-flex justify-content-between align-items-center mb-4 mt-2">
                    <div>
                        <h4 className="font-weight-bold cc-animate-fade" style={{ color: '#0f172a', letterSpacing: '-0.5px' }}>
                            Student Communications
                        </h4>
                        <p className="text-muted small mb-0">Unified student interaction portal.</p>
                    </div>
                    
                    {/* Channel Switcher Tabs (Premium) */}
                    <div className="af-shadcn-tabs mb-0 bg-white shadow-sm border">
                        <button className={`af-tabs-trigger px-3 py-2 ${activeTab === 'whatsapp' ? 'active' : ''}`} onClick={() => this.handleTabSelect('whatsapp')}>
                            <i className="fab fa-whatsapp" />
                        </button>
                        <button className={`af-tabs-trigger px-3 py-2 ${activeTab === 'sms' ? 'active' : ''}`} onClick={() => this.handleTabSelect('sms')}>
                            <i className="fas fa-sms" />
                        </button>
                        <button className={`af-tabs-trigger px-3 py-2 ${activeTab === 'email' ? 'active' : ''}`} onClick={() => this.handleTabSelect('email')}>
                            <i className="fas fa-envelope" />
                        </button>
                    </div>
                </div>

                <div className="cc-pro-layout">
                    {/* ══ PANE 1: THE REGISTRY (LEFT) ══ */}
                    <aside className={`cc-pro-registry ${registryOpen ? 'open' : ''}`}>
                        <div className="pane-header">
                            <div className="title">
                                <span>STUDENT DIRECTORY ({filteredStudents.length})</span>
                                <button className="cc-tool-btn" onClick={this.selectAllStudents} title="Toggle selection filter">
                                    <i className="fas fa-check-double" />
                                </button>
                            </div>
                            <InputGroup className="af-search-group shadow-none mb-3">
                                <InputGroup.Prepend>
                                    <InputGroup.Text className="bg-transparent border-right-0 text-muted">
                                        <i className="fas fa-search" />
                                    </InputGroup.Text>
                                </InputGroup.Prepend>
                                <Form.Control
                                    placeholder="Search details..."
                                    className="border-left-0 shadow-none"
                                    value={searchQuery}
                                    onChange={(e) => this.setState({ searchQuery: e.target.value })}
                                />
                            </InputGroup>
                            
                            <div className="af-filter-actions d-flex gap-2 pb-1">
                                {/* BRANCH FILTER */}
                                <Dropdown className="flex-shrink-0">
                                    <Dropdown.Toggle variant="light" size="sm" className={`cc-tool-btn w-auto px-2 ${this.state.selectedBranches.length > 0 ? 'active' : ''}`}>
                                        <i className="fas fa-building mr-2" /> 
                                        Branch {this.state.selectedBranches.length > 0 && `(${this.state.selectedBranches.length})`}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className="af-multi-menu p-3 shadow-lg border-0" style={{minWidth: '260px'}}>
                                        <div className="d-flex justify-content-between align-items-center mb-2 px-1">
                                            <h6 className="multi-menu-title m-0">SELECT BRANCH</h6>
                                            <Button variant="link" size="sm" className="p-0 text-primary small font-weight-bold text-decoration-none" onClick={this.toggleAllBranches}>
                                                {this.state.selectedBranches.length === this.state.branches.length ? 'Deselect All' : 'Select All'}
                                            </Button>
                                        </div>
                                        <div className="multi-menu-scrollable">
                                            {this.state.branches.map(br => (
                                                <div key={br.id} className="custom-control custom-checkbox mb-1 py-1 hover-bg-light rounded" onClick={(e) => { e.stopPropagation(); this.toggleBranch(br.id); }}>
                                                    <input type="checkbox" id={`branch-${br.id}`} className="custom-control-input" checked={this.state.selectedBranches.includes(String(br.id))} readOnly />
                                                    <label htmlFor={`branch-${br.id}`} className="custom-control-label ml-2 small font-weight-500 text-muted" style={{cursor: 'pointer'}}>{br.branch_name}</label>
                                                </div>
                                            ))}
                                        </div>
                                    </Dropdown.Menu>
                                </Dropdown>

                                {/* TAG FILTER */}
                                <Dropdown className="flex-shrink-0">
                                    <Dropdown.Toggle variant="light" size="sm" className={`cc-tool-btn w-auto px-2 ${this.state.selectedTags.length > 0 ? 'active' : ''}`}>
                                        <i className="fas fa-tags mr-2" /> 
                                        Tag {this.state.selectedTags.length > 0 && `(${this.state.selectedTags.length})`}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className="af-multi-menu p-3 shadow-lg border-0" style={{minWidth: '260px'}}>
                                        <div className="d-flex justify-content-between align-items-center mb-2 px-1">
                                            <h6 className="multi-menu-title m-0">SELECT TAG</h6>
                                            <Button variant="link" size="sm" className="p-0 text-primary small font-weight-bold text-decoration-none" onClick={this.toggleAllTags}>
                                                {this.state.selectedTags.length === this.state.tags.length ? 'Deselect All' : 'Select All'}
                                            </Button>
                                        </div>
                                        <div className="multi-menu-scrollable">
                                            {this.state.tags.map(tag => (
                                                <div key={tag.id} className="custom-control custom-checkbox mb-1 py-1 hover-bg-light rounded" onClick={(e) => { e.stopPropagation(); this.toggleTag(tag.id); }}>
                                                    <input type="checkbox" id={`tag-${tag.id}`} className="custom-control-input" checked={this.state.selectedTags.includes(String(tag.id))} readOnly />
                                                    <label htmlFor={`tag-${tag.id}`} className="custom-control-label ml-2 small font-weight-500 text-muted" style={{cursor: 'pointer'}}>{tag.tag_name}</label>
                                                </div>
                                            ))}
                                        </div>
                                    </Dropdown.Menu>
                                </Dropdown>

                                {(this.state.selectedTags.length > 0 || this.state.selectedBranches.length > 0) && (
                                    <button className="btn btn-link btn-sm p-0 text-danger text-decoration-none ml-2" onClick={() => this.setState({ selectedTags: [], selectedBranches: [] })}>
                                        <i className="fas fa-times-circle" /> Reset
                                    </button>
                                )}
                            </div>
                        </div>

                        <div className="registry-scroll">
                            {filteredStudents.map(student => (
                                <div 
                                    key={student.id} 
                                    className={`cc-item ${this.state.selectedContactId === student.id ? 'active' : ''}`}
                                    onClick={() => this.toggleStudentSelection(student)}
                                >
                                    <div className="avatar-pro">
                                        {selectedStudents.includes(student.id) ? <i className="fas fa-check-circle text-primary" /> : student.student_name.charAt(0)}
                                    </div>
                                    <div className="content">
                                        <span className="name">{student.student_name}</span>
                                        <span className="preview">{activeTab === 'email' ? student.student_email : student.student_mobile}</span>
                                    </div>
                                    <div className="meta">
                                        <div className="time">Just now</div>
                                    </div>
                                </div>
                            ))}
                            {filteredStudents.length === 0 && (
                                <div className="text-center py-5 text-muted small px-3">No matching students found.</div>
                            )}
                        </div>
                    </aside>

                    {/* ══ PANE 2: THE WORKSPACE (CENTER) ══ */}
                    <main className="cc-pro-workspace">
                        <header className="workspace-header shadow-sm">
                            <div className="d-flex align-items-center">
                                <button className="cc-tool-btn mr-3 d-lg-none" onClick={this.toggleRegistry}>
                                    <i className="fas fa-bars" />
                                </button>
                                {selectedMobile ? (
                                    <div className="student-info cc-animate-fade">
                                        <h6 className="name">{selectedStudentName}</h6>
                                        <div className="status">Real-time Session</div>
                                    </div>
                                ) : (
                                    <div className="text-muted small italic">Select an inbox item to begin...</div>
                                )}
                            </div>
                            <div className="workspace-actions">
                                <button className={`cc-tool-btn ${showTimeline ? 'active' : ''} mr-2`} onClick={() => this.setState({ showTimeline: !showTimeline })} title="Conversation History">
                                    <i className="fas fa-history" />
                                </button>
                                <button className="cc-tool-btn d-xl-none" onClick={this.toggleInspector}>
                                    <i className="fas fa-id-card" />
                                </button>
                            </div>
                        </header>

                        <div className="timeline-container">
                            {selectedMobile && showTimeline ? (
                                <div className="h-100 cc-animate-fade">
                                    <TimelineViewer 
                                        mobile={selectedMobile}
                                        studentName={selectedStudentName}
                                        contactId={selectedContactId}
                                        employeeId={this.state.employeeId}
                                    />
                                </div>
                            ) : (
                                <div className="h-100 d-flex flex-column align-items-center justify-content-center text-muted p-5 opacity-40">
                                    <i className="fas fa-comments fa-4x mb-4" />
                                    <p className="text-center h6">Select a student record to start a transmission or view academic interaction history.</p>
                                </div>
                            )}
                        </div>

                        <div className="composer-area shadow-sm">
                            <div className="composer-card">
                                {selectedTemplate && (
                                    <div className="px-3 pt-2 pb-1 border-bottom d-flex align-items-center justify-content-between bg-white rounded-top">
                                        <span className="small font-weight-bold text-primary">
                                            <i className="fas fa-magic mr-2" /> Application Template
                                        </span>
                                        <button className="btn btn-link btn-sm text-muted p-0" onClick={() => this.setState({ selectedTemplate: '', messageBody: '' })}>
                                            <i className="fas fa-times" />
                                        </button>
                                    </div>
                                )}
                                <textarea 
                                    className="textarea-pro"
                                    placeholder={selectedStudents.length > 0 ? `Compose to ${selectedStudents.length} selected...` : "Choose recipients to compose..."}
                                    value={messageBody}
                                    onChange={(e) => this.setState({ messageBody: e.target.value })}
                                />
                                <div className="actions-bar bg-light rounded-bottom">
                                    <div className="left-tools">
                                        <Dropdown drop="up">
                                            <Dropdown.Toggle variant="link" className="cc-tool-btn p-0 shadow-none border-0">
                                                <i className="fas fa-plus-circle fa-lg" />
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu className="shadow-lg border-0 p-3" style={{minWidth: '320px', borderRadius: '12px'}}>
                                                <h6 className="section-label mb-3" style={{fontSize: '10px', color: '#64748b'}}>CONFIGURATION</h6>
                                                
                                                <Form.Group className="mb-3">
                                                    <label className="small font-weight-bold">Select Template</label>
                                                    <Form.Control as="select" className="form-control-sm" value={selectedTemplate} onChange={this.handleTemplateChange}>
                                                        <option value="">Manual Construct</option>
                                                        {activeTab === 'whatsapp' && this.state.whatsappTemplates.map(t => <option key={t.id} value={t.id}>{t.template_name}</option>)}
                                                        {activeTab === 'sms' && this.state.smsTemplates.map(t => <option key={t.template_id} value={t.template_id}>{t.template_name}</option>)}
                                                    </Form.Control>
                                                </Form.Group>

                                                {activeTab === 'whatsapp' && !selectedTemplate && (
                                                    <div className="border-top pt-3">
                                                        <label className="small font-weight-bold">Media Integration</label>
                                                        <Row className="gx-2">
                                                            <Col xs={4}>
                                                                <Form.Control as="select" className="form-control-sm" value={this.state.mediaType} onChange={(e) => this.setState({ mediaType: e.target.value })}>
                                                                    <option value="text">None</option>
                                                                    <option value="image">Image</option>
                                                                    <option value="video">Video</option>
                                                                </Form.Control>
                                                            </Col>
                                                            <Col xs={8}>
                                                                <Form.Control type="text" placeholder="Embed URL..." className="form-control-sm" value={this.state.mediaUrl} onChange={(e) => this.setState({ mediaUrl: e.target.value })} />
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                )}
                                                
                                                {activeTab === 'email' && (
                                                    <Form.Group className="mb-0 pt-2 border-top">
                                                        <label className="small font-weight-bold">Subject Line</label>
                                                        <Form.Control type="text" placeholder="Protocol subject..." className="form-control-sm" value={emailSubject} onChange={(e) => this.setState({ emailSubject: e.target.value })} />
                                                    </Form.Group>
                                                )}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                        <div className="border-right mx-2 h-20" />
                                        <button className="cc-tool-btn" onClick={() => this.setState({ messageBody: messageBody + ' {student_name}' })} title="Inject Student Name Mapping">
                                            <i className="fas fa-user-tag" />
                                        </button>
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <span className="small text-muted mr-3 font-weight-500">
                                            {messageBody.length} px
                                        </span>
                                        <button 
                                            className="send-btn" 
                                            onClick={this.handleSend}
                                            disabled={sending || selectedStudents.length === 0 || !messageBody.trim()}
                                        >
                                            {sending ? <Spinner animation="border" size="sm" /> : <><i className="fas fa-paper-plane mr-2" /> Send Message</>}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>

                    {/* ══ PANE 3: THE INSPECTOR (RIGHT) ══ */}
                    <aside className={`cc-pro-inspector ${inspectorOpen ? 'open' : ''}`}>
                        {selectedContactId ? (
                            <div className="cc-animate-fade h-100 d-flex flex-column">
                                <header className="d-flex justify-content-between align-items-center mb-4">
                                    <h6 className="m-0 font-weight-bold text-dark">ADMISSION INSIGHTS</h6>
                                    <button className="cc-tool-btn d-xl-none" onClick={this.toggleInspector}>
                                        <i className="fas fa-times" />
                                    </button>
                                </header>
                                
                                <div className="flex-fill overflow-auto pr-1">
                                    <LeadSidecar 
                                        contactId={selectedContactId}
                                        studentName={selectedStudentName}
                                        employeeId={this.state.employeeId}
                                        onUpdate={() => console.log("Context refreshed")}
                                    />
                                </div>
                            </div>
                        ) : (
                            <div className="text-center py-5 text-muted small px-3 mt-5 opacity-40">
                                <i className="fas fa-shield-alt fa-3x mb-4" />
                                <p className="font-weight-bold">Profile Analytics</p>
                                <p>Select an active contact to inspect admission scoring and staff metadata.</p>
                            </div>
                        )}
                    </aside>
                </div>
                
                {/* Mobile Overlay for Drawers */}
                <div 
                    className={`cc-mobile-overlay ${(registryOpen || inspectorOpen) ? 'active' : ''}`} 
                    onClick={this.closeDrawers}
                />
            </div>
        );
    }
}

export default withRouter(compose()(withApollo(CommunicationsCenterPage)));
